import { dateLocale } from "@/lib/dateTime";
export interface DealSummary {
  age_days: number;
  /** The lead this deal was converted from: its source, and how hot the lead was */
  origin: { lead_id: string; source: string | null; priority: string | null; created_on: string } | null;
  stages: { id: string; name: string; key: string | null; state: "done" | "now" | "later"; days: number | null }[];
  account: { id: string; name: string; state: string | null; since: string; lifetime_won: number; open_deals: number } | null;
  qualification: Record<"budget" | "authority" | "need" | "timeline", { ok: boolean; text: string }>;
}

export const fmtDay = (d?: string | null) => (d ? new Date(d.length === 10 ? `${d}T00:00:00` : d).toLocaleDateString(dateLocale(), { day: "2-digit", month: "short" }) : "No date");
